const getImps = (margin) => {
    const m = Math.abs(margin);
    if (m <= 10) return 0;
    if (m <= 40) return 1;
    if (m <= 80) return 2;
    if (m <= 120) return 3;
    if (m <= 160) return 4;
    if (m <= 210) return 5;
    if (m <= 260) return 6;
    if (m <= 310) return 7;
    if (m <= 360) return 8;
    if (m <= 420) return 9;
    if (m <= 490) return 10;
    if (m <= 590) return 11;
    if (m <= 740) return 12;
    if (m <= 890) return 13;
    if (m <= 1090) return 14;
    if (m <= 1290) return 15;
    if (m <= 1490) return 16;
    if (m <= 1740) return 17;
    if (m <= 1990) return 18;
    if (m <= 2240) return 19;
    if (m <= 2490) return 20;
    if (m <= 2990) return 21;
    if (m <= 3490) return 22;
    if (m <= 3990) return 23;
    return 24; // 4000 or more
};

export const parseAliases = (csvString) => {
    if (!csvString) return {};
    const aliasMap = {};
    const lines = csvString.split('\n');
    lines.forEach(line => {
        const parts = line.split(',');
        if (parts.length >= 2) {
            const handle = parts[0].trim();
            const realName = parts.slice(1).join(',').trim(); 
            if (handle) aliasMap[handle] = realName;
        }
    });
    return aliasMap;
};

// 3. Standard Vulnerability Map
const VULNERABILITIES = [
    'None', 'NS', 'EW', 'Both', 
    'NS', 'EW', 'Both', 'None', 
    'EW', 'Both', 'None', 'NS', 
    'Both', 'None', 'NS', 'EW'
];
const getVul = (boardNum) => VULNERABILITIES[(boardNum - 1) % 16];

// 4. The Mini Bridge Scoring Engine
const calculateRawScore = (contractStr, boardNum) => {
    if (!contractStr || contractStr.trim() === '' || contractStr.toUpperCase() === 'P' || contractStr.toUpperCase() === 'PASS') return 0;

    // Parses string like "4SWx-2" or "3NN+1"
    const match = contractStr.trim().match(/^([1-7])([CDHSN])([NESW])(x|xx|)([-=+]?)(\d*)$/i);
    if (!match) return 0;

    const level = parseInt(match[1]);
    const suit = match[2].toUpperCase();
    const declarer = match[3].toUpperCase();
    const dbl = match[4].toLowerCase();
    const res = match[5];
    const tricks = match[6] ? parseInt(match[6]) : 0;

    const vulState = getVul(boardNum);
    const isVul = (declarer === 'N' || declarer === 'S') ? (vulState === 'NS' || vulState === 'Both') : (vulState === 'EW' || vulState === 'Both');

    // Base Points
    let basePoints = 0;
    if (suit === 'C' || suit === 'D') basePoints = 20 * level;
    else if (suit === 'H' || suit === 'S') basePoints = 30 * level;
    else if (suit === 'N') basePoints = 40 + 30 * (level - 1);

    const multiplier = dbl === 'xx' ? 4 : dbl === 'x' ? 2 : 1;
    const contractPoints = basePoints * multiplier;

    let score = 0;

    if (res === '=' || res === '+') {
        const overtricks = res === '+' ? tricks : 0;
        
        // Game & Partscore Bonus
        if (contractPoints >= 100) score += isVul ? 500 : 300;
        else score += 50;

        // Slam Bonus
        if (level === 6) score += isVul ? 750 : 500;
        else if (level === 7) score += isVul ? 1500 : 1000;

        // Insult Bonus
        if (dbl === 'x') score += 50;
        else if (dbl === 'xx') score += 100;

        score += contractPoints;

        // Overtrick Points
        if (dbl === '') score += overtricks * (suit === 'C' || suit === 'D' ? 20 : 30);
        else if (dbl === 'x') score += overtricks * (isVul ? 200 : 100);
        else score += overtricks * (isVul ? 400 : 200);

    } else if (res === '-') {
        const u = tricks;
        if (dbl === '') {
            score = -(u * (isVul ? 100 : 50));
        } else if (dbl === 'x') {
            if (!isVul) {
                let pen = 100;
                if (u >= 2) pen += 200;
                if (u >= 3) pen += 200;
                if (u >= 4) pen += (u - 3) * 300;
                score = -pen;
            } else {
                let pen = 200;
                if (u >= 2) pen += 300;
                if (u >= 3) pen += (u - 2) * 300;
                score = -pen;
            }
        } else if (dbl === 'xx') {
            if (!isVul) {
                let pen = 200;
                if (u >= 2) pen += 400;
                if (u >= 3) pen += 400;
                if (u >= 4) pen += (u - 3) * 600;
                score = -pen;
            } else {
                let pen = 400;
                if (u >= 2) pen += 600;
                if (u >= 3) pen += (u - 2) * 600;
                score = -pen;
            }
        }
    }

    // Return strictly from N/S Perspective (+ means N/S scored, - means E/W scored)
    return (declarer === 'N' || declarer === 'S') ? score : -score;
};

export const calculateBeerPoints = (contractStr, playArr) => {
    // Must be a fully played out hand (13 tricks = 52 cards). No claims!
    if (!playArr || playArr.length < 52) return { ns: 0, ew: 0 };
    const match = contractStr.trim().match(/^([1-7])([CDHSN])([NESW])(x|xx|)([-=+]?)(\d*)$/i);
    if (!match) return { ns: 0, ew: 0 };

    const trump = match[2].toUpperCase();
    if (trump === 'D') return { ns: 0, ew: 0 }; // Diamonds cannot be trump

    const declarer = match[3].toUpperCase();
    const dbl = match[4].toLowerCase();
    const res = match[5];

    const ranks = { '2':2, '3':3, '4':4, '5':5, '6':6, '7':7, '8':8, '9':9, 'T':10, 'J':11, 'Q':12, 'K':13, 'A':14 };
    const seats = ['N', 'E', 'S', 'W'];
    let leaderIdx = (seats.indexOf(declarer) + 1) % 4; // LHO leads Trick 1

    let trickWinnerSeat = '';
    let winningCard = '';

    // Simulate all 13 tricks to find out who won Trick 13 and with what card
    for (let t = 0; t < 13; t++) {
        const trickCards = playArr.slice(t * 4, t * 4 + 4);
        if (trickCards.length < 4) return { ns: 0, ew: 0 };

        let leadSuit = trickCards[0].charAt(0).toUpperCase();
        let highestVal = -1;
        let trickWinnerIdx = 0;

        for (let i = 0; i < 4; i++) {
            const card = trickCards[i].toUpperCase();
            const suit = card.charAt(0);
            const rank = ranks[card.charAt(1)];

            let val = 0;
            if (suit === trump) val = 100 + rank; // Trump beats all
            else if (suit === leadSuit) val = rank; // Follow suit

            if (val > highestVal) {
                highestVal = val;
                trickWinnerIdx = i;
                winningCard = card;
            }
        }
        trickWinnerSeat = seats[(leaderIdx + trickWinnerIdx) % 4];
        leaderIdx = (leaderIdx + trickWinnerIdx) % 4; // Winner leads next
    }

    // Must win Trick 13 with the 7 of Diamonds
    if (winningCard !== 'D7') return { ns: 0, ew: 0 };

    let pts = 0;
    let winnerSide = (trickWinnerSeat === 'N' || trickWinnerSeat === 'S') ? 'NS' : 'EW';
    const declarerSide = (declarer === 'N' || declarer === 'S') ? 'NS' : 'EW';
    const made = (res === '=' || res === '+');

    if (winnerSide === declarerSide && made) pts = 1; // Declarer made & won last trick with D7
    else if (winnerSide !== declarerSide && !made) pts = 2; // Defender set & won last trick with D7
    else return { ns: 0, ew: 0 };

    // Apply Doubles
    if (dbl === 'x') pts *= 2;
    else if (dbl === 'xx') pts *= 4;

    return {
        ns: winnerSide === 'NS' ? pts : 0,
        ew: winnerSide === 'EW' ? pts : 0
    };
};

const fixMangledUnicode = (str) => {
    if (!str) return "";

    // 1. Handle BBO URL encoding if present
    let text = str;
    try { 
        text = decodeURIComponent(str.replace(/\+/g, ' ')); 
    } catch (e) { /* ignore and use raw */ }

    // 2. Windows-1252 to Byte Mapping
    // Maps browser-normalized characters back to their raw 0-255 byte values.
    const win1252Map = {
        0x2013: 0x96, 0x2014: 0x97, 0x2018: 0x91, 0x2019: 0x92, 
        0x201C: 0x93, 0x201D: 0x94, 0x2022: 0x95, 0x2026: 0x85, 
        0x2122: 0x99, 0x0153: 0x9C, 0x0178: 0x9F, 0x20AC: 0x80,
        0x02DC: 0x98, 0x203A: 0x9B, 0x2039: 0x8B, 0x0161: 0x9A,
        0x017E: 0x9E, 0x0152: 0x8C, 0x0192: 0x83, 0x2020: 0x86,
        0x2021: 0x87, 0x02C6: 0x88, 0x2030: 0x89, 0x0160: 0x8A
    };

    try {
        const bytes = new Uint8Array(text.length);
        for (let i = 0; i < text.length; i++) {
            const code = text.charCodeAt(i);
            // Revert normalized chars to raw bytes, otherwise take the lower 8 bits
            bytes[i] = win1252Map[code] || (code & 0xff);
        }
        
        // Throw an error if it's not valid UTF-8 so we can fall back to raw text
        const utf8Decoder = new TextDecoder('utf-8', { fatal: true });
        return utf8Decoder.decode(bytes);
    } catch (e) {
        return text;
    }
};

// 5. The Main LIN Parser
export const parseLin = (linString, aliases = {}) => {
    if (!linString || typeof linString !== 'string') throw new Error("Invalid LIN data provided.");

    // FIX: Strip all hidden newlines so tags like '\nrs' become clean 'rs' tags
    const cleanedLin = linString.replace(/[\r\n]+/g, '');
    const tokens = cleanedLin.split('|');
    const parsedData = {
        title: "Match",
        startBoard: 1,
        team1Name: "Team 1",
        team2Name: "Team 2",
        players: [],
        total_imps1: 0,
        total_imps2: 0,
        boards: [] 
    };

    // Extract Metadata (vg)
    const vgIndex = tokens.indexOf('vg');
    if (vgIndex !== -1 && tokens.length > vgIndex + 1) {
        const vgData = tokens[vgIndex + 1].split(',');
        if (vgData.length >= 7) {
            parsedData.title = vgData[0];
            parsedData.startBoard = parseInt(vgData[3]) || 1;
            parsedData.team1Name = vgData[5];
            parsedData.team2Name = vgData[7];
        }
    }

    // Extract Players (pn) & Apply Aliases
    const pnIndex = tokens.indexOf('pn');
    if (pnIndex !== -1 && tokens.length > pnIndex + 1) {
        const rawPlayers = tokens[pnIndex + 1].split(',');
        parsedData.players = rawPlayers.map(p => aliases[p.trim()] || p.trim());
    }

    // --- NEW: Extract Rich Data (Hands, Bidding, Play) sequentially ---
    const richData = {}; // Stores details by board number
    let currRoom = null; // 'o' for Open, 'c' for Closed
    let currBoard = null;

    for (let i = 0; i < tokens.length; i++) {
        const key = tokens[i];
        const val = tokens[i + 1];

        // qx marks the start of a specific board in a specific room (e.g., "o11" or "c11")
        if (key === 'qx' && val) {
            currRoom = val.charAt(0).toLowerCase(); 
            const bNumMatch = val.match(/\d+/);
            currBoard = bNumMatch ? parseInt(bNumMatch[0]) : null;
            
            if (currBoard && !richData[currBoard]) {
                richData[currBoard] = { 
                    o: { hands: '', bidding: [], play: [], claim: '', players: [], alerts: [] }, 
                    c: { hands: '', bidding: [], play: [], claim: '', players: [], alerts: [] } 
                };
            }
        } 
        // If we are actively tracking a board, collect its data
        else if (currBoard && currRoom && richData[currBoard][currRoom]) {
            if (key === 'pn') richData[currBoard][currRoom].players = val.split(',').map(p => aliases[p.trim()] || p.trim());
            else if (key === 'md') richData[currBoard][currRoom].hands = val;
            // else if (key === 'mb') richData[currBoard][currRoom].bidding.push(val);
            else if (key === 'mb') {
                richData[currBoard][currRoom].bidding.push(val);
                richData[currBoard][currRoom].alerts.push(''); // Keep alerts array perfectly in sync!
            }
            else if (key === 'an') {
                // 1. Get the actual Array reference (DO NOT wrap this in fixMangledUnicode)
                const alertsArr = richData[currBoard][currRoom].alerts;
                
                if (alertsArr.length > 0) {
                    let rawAlert = val || 'Alert';
                    
                    // 2. Fix the encoding on the STRING 'val', then save it to the Array
                    // We'll move the heavy-duty decoding logic into the helper for cleanliness
                    alertsArr[alertsArr.length - 1] = fixMangledUnicode(rawAlert);
                }
            }
            // else if (key === 'an') {
            //     const alertsArr = richData[currBoard][currRoom].alerts;
            //     if (alertsArr.length > 0) {
            //         let safeAlert = val || 'Alert';
            //         try {
            //             // BBO often URL encodes unicode characters in alerts!
            //             safeAlert = decodeURIComponent(escape(val));
            //         } catch (e) {
            //             try { safeAlert = decodeURIComponent(val); } catch (e2) {}
            //         }
            //         alertsArr[alertsArr.length - 1] = safeAlert;
            //     }
            // }
            else if (key === 'pc') richData[currBoard][currRoom].play.push(val);
            else if (key === 'mc') richData[currBoard][currRoom].claim = val;
        }
    }

    // --- Extract Results (rs) & Tie Everything Together ---
    parsedData.total_bam1 = 0;
    parsedData.total_bam2 = 0;
    parsedData.total_beer1 = 0;
    parsedData.total_beer2 = 0;

    let currentBoard = parsedData.startBoard;
    const originalOpen = new Set();
    const originalClosed = new Set();

    // 🚨 FIX: Iterate through all tokens to handle multiple concatenated .lin files!
    for (let tIdx = 0; tIdx < tokens.length; tIdx++) {
        if (tokens[tIdx] === 'rs' && tokens.length > tIdx + 1) {
            const rsData = tokens[tIdx + 1].split(',');

            for (let i = 0; i < rsData.length; i += 2) {
                let room1Contract = rsData[i] || "";
                let room2Contract = rsData[i + 1] || "";
                
                // 🚨 FIX: If Omitted, skip entirely. It will never enter the boards array!
                if (room1Contract === "" && room2Contract === "") {
                    currentBoard++;
                    continue;
                }

                // --- SMART ROOM SWAP DETECTION (THE PINNING ENGINE) ---
                let isSwapped = false;
                const oPlayers = richData[currentBoard]?.o?.players || [];
                const cPlayers = richData[currentBoard]?.c?.players || [];

                const oHasClosedHuman = oPlayers.some(p => p && !p.startsWith('~') && originalClosed.has(p));
                const cHasOpenHuman = cPlayers.some(p => p && !p.startsWith('~') && originalOpen.has(p));

                if (oHasClosedHuman || cHasOpenHuman) isSwapped = true;

                if (isSwapped) {
                    oPlayers.forEach(p => { if (p && !p.startsWith('~')) originalClosed.add(p); });
                    cPlayers.forEach(p => { if (p && !p.startsWith('~')) originalOpen.add(p); });
                } else {
                    oPlayers.forEach(p => { if (p && !p.startsWith('~')) originalOpen.add(p); });
                    cPlayers.forEach(p => { if (p && !p.startsWith('~')) originalClosed.add(p); });
                }

                if (isSwapped) {
                    const tempContract = room1Contract;
                    room1Contract = room2Contract;
                    room2Contract = tempContract;

                    if (richData[currentBoard]) {
                        const tempDetails = richData[currentBoard].o;
                        richData[currentBoard].o = richData[currentBoard].c;
                        richData[currentBoard].c = tempDetails;
                    }
                }
                // --- END SMART DETECTION ---

                const raw1 = calculateRawScore(room1Contract, currentBoard); 
                const raw2 = calculateRawScore(room2Contract, currentBoard); 

                const team1Margin = raw1 - raw2;
                const imps = getImps(team1Margin);

                let imps1 = 0;
                let imps2 = 0;
                let bam1 = 0.5;
                let bam2 = 0.5;

                // Auto-BAM
                if (team1Margin > 0) { imps1 = imps; parsedData.total_imps1 += imps; bam1 = 1; bam2 = 0; }
                else if (team1Margin < 0) { imps2 = imps; parsedData.total_imps2 += imps; bam1 = 0; bam2 = 1; }
                
                parsedData.total_bam1 += bam1;
                parsedData.total_bam2 += bam2;

                // Auto-Beer
                const oDetails = richData[currentBoard]?.o;
                const cDetails = richData[currentBoard]?.c;
                
                const r1Beer = oDetails ? calculateBeerPoints(room1Contract, oDetails.play) : { ns: 0, ew: 0 };
                const r2Beer = cDetails ? calculateBeerPoints(room2Contract, cDetails.play) : { ns: 0, ew: 0 };

                // T1 is Home NS + Away EW. T2 is Home EW + Away NS.
                const boardBeer1 = r1Beer.ns + r2Beer.ew;
                const boardBeer2 = r1Beer.ew + r2Beer.ns;
                
                parsedData.total_beer1 += boardBeer1;
                parsedData.total_beer2 += boardBeer2;

                parsedData.boards.push({
                    boardNum: currentBoard,
                    room1: room1Contract,
                    room2: room2Contract,
                    raw1: raw1, 
                    raw2: raw2,
                    rawMargin: team1Margin,
                    imps1: imps1,
                    imps2: imps2,
                    bam1: bam1,
                    bam2: bam2,
                    beer1: boardBeer1,
                    beer2: boardBeer2,
                    r1BeerObj: r1Beer,
                    r2BeerObj: r2Beer,
                    swapped: isSwapped, 
                    details: richData[currentBoard] || { o: null, c: null }
                });

                currentBoard++;
            }
        }
    }

    return parsedData;
};